// extracted by mini-css-extract-plugin
export default {"wrapper":"not-found_wrapper__WfeGO"};